import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Alert, Badge, Modal, ModalBody, ModalHeader, Table } from 'reactstrap'
import Loader from '../../../common/Loader'
import useSWRFetch from '../../../../helpers/hooks/useSWRFetch'
import { getRewardRuleHistory } from '../../../../helpers/api/rewardsAdmin'
import { formatDate } from '../../../rewards/rewardsUtils'
import { formatRuleValue, getRuleDefinition } from '../rewardsAdminUtils'

// HO-TASK-289: todas las versiones de un parámetro con su vigencia
// (GET /rewards/config/{key}/history).
const RuleHistoryModal = ({ ruleKey, onClose }) => {
  const { data, error, isLoading } = useSWRFetch(
    ruleKey ? ['rewards-rule-history', ruleKey] : null,
    (key, historyKey) => getRewardRuleHistory(historyKey)
  )
  const versions = data?.data || []
  const today = moment().format('YYYY-MM-DD')

  const status = (version) => {
    if (version.valid_from > today) return <Badge color="soft-info" pill>Programado</Badge>
    if (!version.valid_to || version.valid_to >= today) return <Badge color="soft-success" pill>Vigente</Badge>
    return null
  }

  return (
    <Modal isOpen={!!ruleKey} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Historial · {getRuleDefinition(ruleKey).label}</ModalHeader>
      <ModalBody>
        {isLoading && ruleKey && <Loader padding="py-4" />}
        {error && <Alert color="danger" className="fs--1 mb-0">No pudimos cargar el historial.</Alert>}
        {data && versions.length === 0 && <p className="fs--1 text-600 mb-0">Este parámetro no tiene versiones.</p>}
        {versions.length > 0 && (
          <Table size="sm" responsive className="fs--1 mb-0">
            <thead className="bg-200 text-900">
              <tr>
                <th>Valor</th>
                <th>Desde</th>
                <th>Hasta</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {versions.map((version) => (
                <tr key={version.id}>
                  <td className="font-weight-semi-bold text-nowrap">{formatRuleValue(ruleKey, version.value)}</td>
                  <td className="text-nowrap">{formatDate(version.valid_from)}</td>
                  <td className="text-nowrap">{version.valid_to ? formatDate(version.valid_to) : 'Sin fecha de fin'}</td>
                  <td className="text-right">{status(version)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
    </Modal>
  )
}

RuleHistoryModal.propTypes = { ruleKey: PropTypes.string, onClose: PropTypes.func.isRequired }

export default RuleHistoryModal
